import React from "react";
import { LayoutBackground } from "assets/js/Styles";
import Navbar from "./navbar";

const Layout2 = ({ children }) => {
  return (
    <LayoutBackground>
      <Navbar />
      {children}
    </LayoutBackground>
  );
};

export default Layout2;
